import { ErrorHandler, Injectable } from '@angular/core';
import { LogglyService } from './services/loggly.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

 constructor(private logglyService: LogglyService) {}

 public handleError(error: any): void {
    let errObj = {
      message: error?.message || error.toString?.() || error,
      stack: error?.stack,
    };
    this.logglyService.error(errObj);
  }

}
